<h4 class="plinko-bs__title typography-title flex items-center gap-4">
  <app-game-icon game="Plinko"></app-game-icon>
  Place Your Bet
</h4>
<div class="plinko-bs--modes">
  <button [class.active]="manual" (click)="changeManual(true)">Manual</button>
  <button [class.active]="!manual" (click)="changeManual(false)">
    Automatic
  </button>
</div>
<div class="plinko-bs__inputs">
  <div class="plinko-bs--bet-input">
    <app-old-slider
      [(value)]="betAmount"
      [max]="plinkoService.MAX_BET"
      [step]="0.1"
      [disabled]="autoActivated()"
      [uiSettings]="{
        thumbSize: '12px',
        trackHeight: '6px',
    }"
    ></app-old-slider>
    <app-input-options
      [(value)]="betAmount"
      [icon]="sessionService.balanceIconSrc()"
      [options]="betInputOptions"
      [disabledInput]="autoActivated()"
      [disabledOptions]="autoActivated()"
      [placeholder]="sessionService.balanceType() + ' value'"
      [settings]="{
      optionType: 'square',
      maskSettings: {
        mask: 'separator.2',
      },
    }"
    />
  </div>
  <div class="plinko-bs--bet-buttons">
    @for (item of betButtons; track $index) {
    <button
      class="button button--style-primary button--style-primary-bordered padding-x-8 rounded-4 h-32"
      (click)="item.fn()"
      [disabled]="autoActivated()"
    >
      <app-balance-icon
        [balance]="sessionService.balanceType()"
        color="var(--yellow)"
      ></app-balance-icon>
      {{ item.label }}
    </button>
    }
  </div>
  <app-input-options
    label="Rows:"
    [options]="plinkoInputOptions"
    placeholder="Rows"
    [(value)]="plinkoService.currentRows"
    [settings]="{
    optionType: 'square',
  }"
    [disabledInput]="true"
  />
  @if (!manual) {
  <app-input-options
    label="Number of bets:"
    [(value)]="autoBalls"
    placeholder="Number of balls..."
  />
  }
  <div class="plinko-bs--risk-buttons">
    <button
      class="plinko-bs__risk-button low"
      [class.active]="plinkoService.currentRisk() === 'low'"
      (click)="plinkoService.setRisk('low')"
    >
      LOW
    </button>
    <button
      class="plinko-bs__risk-button medium"
      [class.active]="plinkoService.currentRisk() === 'medium'"
      (click)="plinkoService.setRisk('medium')"
    >
      MEDIUM
    </button>
    <button
      class="plinko-bs__risk-button high"
      [class.active]="plinkoService.currentRisk() === 'high'"
      (click)="plinkoService.setRisk('high')"
    >
      HIGH
    </button>
  </div>
  <div class="plinko-bs--animation-slider">
    Animation speed
    <div class="plinko-bs--animation-slider__value">
      <div class="plinko-bs--animation-slider__box">
        {{ plinkoService.animSpeed().toFixed(0) }}x
      </div>
      <app-old-slider
        [(value)]="plinkoService.animSpeed"
        [min]="1"
        [max]="25"
        [uiSettings]="{
            thumbSize: '12px',
            trackHeight: '6px',
          }"
      ></app-old-slider>
    </div>
  </div>
  <button
    class="plinko-bs--button"
    (click)="manual ? drop() : autoActivated() ? stopAuto() : startAuto()"
  >
    @if (manual) { PLACE BET }
    <!--  -->
    @else if (!manual && autoActivated()) {
    <!--  -->
    Stop Auto
    {{ +autoBalls() === 0 ? "- Infinite" : "- " + ballsLeft() + " Balls left" }}
    }
    <!--  -->
    @else if (!manual && !autoActivated()) { Start Auto
    {{ +autoBalls() === 0 ? "- Infinite" : "" }}
    }
  </button>
</div>

<div class="plinko-bs--bottom">
  <app-fairness-button [href]="'/provably-fair/plinko/'"></app-fairness-button>
  <div class="plinko-bs--seed">
    <span class="plinko-bs--seed__title">Client Seed:</span>
    <span
      class="plinko-bs--seed__value"
      (click)="
        clipboardService.copy(
          sessionService.clientSeed()?.seed ?? '',
          'Client Seed copied!'
        )
      "
    >
      {{ sessionService.clientSeed()?.seed }}
    </span>
  </div>
</div>
